import { Fragment } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Provider as JotaiProvider } from 'jotai';

import { routes } from '~/routes';
import MapLayout from './layouts/MapLayout/MapLayout';

import { ConfigProvider } from 'antd';
import ErrorBoundary from '~/components/common/ErrorBoundary';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loading from './components/common/Loading/Loading';
import AuthController from './controllers/AuthController';
import ProjectDataController from './controllers/ProjectController';
import UserStoreController from './controllers/UserStoreController';
import ACLTLGeoController from './controllers/ACLTLGeoController';
import { useAntdLocale } from './hooks/useAntdLocale';

function RoutesContainer() {
  return (
    <Router>
      <Loading />
      <div id="app-id" className="App" style={{ width: '100vw', height: '100vh', background: '#f5f5f5' }}>
        <Routes>
          {routes.map((route, index) => {
            const Page = route.component;
            let Layout: any = MapLayout;
            if (route.layout) {
              Layout = route.layout;
            } else if (route.layout === null) {
              Layout = Fragment;
            }
            return (
              <Route
                path={route.path}
                element={
                  <ErrorBoundary>
                    <Layout>
                      <Page />

                      <ProjectDataController />
                      <AuthController />
                      <ACLTLGeoController />
                      <UserStoreController />
                    </Layout>
                  </ErrorBoundary>
                }
                key={index}
              />
            );
          })}
        </Routes>
      </div>
    </Router>
  );
}

function App() {
  const antdLocale = useAntdLocale();

  return (
    <ConfigProvider
      locale={antdLocale}
      theme={{
        token: {
          fontFamily: "Roboto"
        }
      }}
    >
      <JotaiProvider>
        <ErrorBoundary>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          <RoutesContainer />
        </ErrorBoundary>
      </JotaiProvider>
    </ConfigProvider>
  );
}

export default App;
